<template>
  <div class="gf-field">
    <input v-model="componentValue" :type="type || 'text'" :placeholder="placeholder" />
  </div>
</template>

<script>
import { componentMixin } from './FormCommon'

export default {
  props: ["placeholder", "type"],
  mixins: [componentMixin],
}
</script>
